module.exports = __webpack_public_path__ + "img/enigma-red-3.d8b567c7.png";